import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import home from '@/components/home'


Vue.use(ElementUI);
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('@/components/home'),
    },
    {
      path: '/',
      name: '/',
      redirect: '/main',
      // component: () => import( '@/components/common/main')
      // component: home
    },
    {
      path: '/main',
      name: 'main',
      component: () => import('@/components/common/main'),
    },
    {
      path: '/Tyd',
      name: 'Tyd',
      component: () => import('@/components/project/Tyd.vue')
    },
    {
      path: '/Message',
      name: 'Message',
      component: () => import('@/components/project/Message.vue')
    },
    {
      path: '/Gatherwealth',
      name: 'Gatherwealth',
      component: () => import('@/components/project/Gatherwealth.vue')
    },
    {
      path: '/Smartrent',
      name: 'Smartrent',
      component: () => import('@/components/project/Smartrent.vue')
    },
    {
      path: '/Marketing',
      name: 'Marketing',
      component: () => import('@/components/project/Marketing.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js